import styles from './plotly.module.scss';

// please use those variables for any new graph

// fonts
export const fontFamily = styles.fontFamily;
export const tickFontSize = parseInt(styles.fontSizeXXSmall);
export const titleFontSize = parseInt(styles.fontSizeMediumLarge);
export const piePlotLegendFontSize = parseInt(styles.fontSizeMedium);
export const wellHomeOperationalGraphsTickFontSize = parseInt(styles.fontSizeXSmall);

// colors
export const backgroundColor = styles.backgroundColor;
export const fontColor = styles.fontColor;
export const primaryColor = styles.primaryColor;
export const primaryHoverColor = styles.primaryHoverColor;
export const primarySelectColor = styles.primarySelectColor;
export const plotGlobalAverageLoadColor = styles.plotGlobalAverageLoadColor;
export const plotCumulativeFuelConsumptionColor = styles.plotCumulativeFuelConsumptionColor;
export const plotEddrPlannedDepthCurveColor = styles.plannedDepthCurveColor;
export const plotEddrRealisedDepthCurveColor = styles.realisedDepthCurveColor;
export const plotEddrRealisedCostCurveColor = styles.realisedCostCurveColor;
export const plotEddrPlannedCostCurveColor = styles.plannedCostCurveColor;

export const piePlotFontColor = styles.piePlotFontColor;
export const piePlotTextShadowColor = styles.piePlotTextShadowColor;

export const powerConsumptionPackageStationKeepingColor =
  styles.powerConsumptionPackageStationKeepingColor;
export const powerConsumptionPackageDrillingColor = styles.powerConsumptionPackageDrillingColor;
export const powerConsumptionPackageUtilitiesColor = styles.powerConsumptionPackageUtilitiesColor;

export const wellHomeOperationalPlotsFontColor = styles.wellHomeOperationalPlotsFontColor;
export const wellHomeOperationalPlotsBLUE = styles.wellHomeOperationalPlotsBLUE;
export const wellHomeOperationalPlotsORANGE = styles.wellHomeOperationalPlotsORANGE;
export const wellHomeOperationalPlotsGREEN = styles.wellHomeOperationalPlotsGREEN;
export const wellHomeOperationalPlotsWHITE = styles.wellHomeOperationalPlotsWHITE;
export const wellHomeOperationalPlotsRED = styles.wellHomeOperationalPlotsRED;
export const wellHomeOperationalPlotsYELLOW = styles.wellHomeOperationalPlotsYELLOW;
export const wellHomeOperationalPlotsPINK = styles.wellHomeOperationalPlotsPINK;
export const wellHomeOperationalPlotsPINKRED = styles.wellHomeOperationalPlotsPINKRED;
export const wellHomeOperationalPlotsPRUPLE = styles.wellHomeOperationalPlotsPRUPLE;
export const wellHomeOperationalPlotsSHAMPOO = styles.wellHomeOperationalPlotsSHAMPOO;
export const wellHomeOperationalPlotsGOLD = styles.wellHomeOperationalPlotsGOLD;
export const wellHomeOperationalPlotsBROWN = styles.wellHomeOperationalPlotsBROWN;
export const wellHomeOperationalPlotsSANDYBROWN = styles.wellHomeOperationalPlotsSANDYBROWN;
export const wellHomeOperationalPlotsHAWAIIBLUE = styles.wellHomeOperationalPlotsHAWAIIBLUE;
export const wellHomeOperationalPlotsLIGHTGREEN = styles.wellHomeOperationalPlotsLIGHTGREEN;

// Rop Offset Well  color

const ropOffsetWellColorAmaranth = styles.ropOffsetWellColorAmaranth;
const ropOffsetWellColorTanHide = styles.ropOffsetWellColorTanHide;
const ropOffsetWellColorDeepSeaGreen = styles.ropOffsetWellColorDeepSeaGreen;
const ropOffsetWellColorShadowGreen = styles.ropOffsetWellColorShadowGreen;
const ropOffsetWellColorTacha = styles.ropOffsetWellColorTacha;
const ropOffsetWellColorMarigoldYellow = styles.ropOffsetWellColorMarigoldYellow;
const ropOffsetWellColorFoggyGray = styles.ropOffsetWellColorFoggyGray;
const ropOffsetWellColorMountainMeadow = styles.ropOffsetWellColorMountainMeadow;
const ropOffsetWellColorLavenderPurple = styles.ropOffsetWellColorLavenderPurple;
const ropOffsetWellColorGlacier = styles.ropOffsetWellColorGlacier;
const ropOffsetWellColorTulipTree = styles.ropOffsetWellColorTulipTree;
const ropOffsetWellColorCinderella = styles.ropOffsetWellColorCinderella;
const ropOffsetWellColorOsloGray = styles.ropOffsetWellColorOsloGray;
const ropOffsetWellColorJaffa = styles.ropOffsetWellColorJaffa;

export const ropOffsetWellColors = [
  ropOffsetWellColorAmaranth,
  ropOffsetWellColorTanHide,
  ropOffsetWellColorDeepSeaGreen,
  ropOffsetWellColorShadowGreen,
  ropOffsetWellColorTacha,
  ropOffsetWellColorMarigoldYellow,
  ropOffsetWellColorFoggyGray,
  ropOffsetWellColorMountainMeadow,
  ropOffsetWellColorLavenderPurple,
  ropOffsetWellColorGlacier,
  ropOffsetWellColorTulipTree,
  ropOffsetWellColorCinderella,
  ropOffsetWellColorOsloGray,
  ropOffsetWellColorJaffa,
];

export const FONT = {
  size: tickFontSize,
  family: fontFamily,
  color: fontColor,
};

export const TITLE_FONT = {
  ...FONT,
  size: titleFontSize,
};

export const PIE_PLOT_LEGEND_FONT = {
  ...FONT,
  size: piePlotLegendFontSize,
  color: piePlotFontColor,
};

export const WELL_HOME_OPERATIONAL_GRAPHS = {
  ...FONT,
  size: wellHomeOperationalGraphsTickFontSize,
  color: wellHomeOperationalPlotsFontColor,
};

// bar width limitation for bar charts
export const MAX_BAR_WIDTH = 0.32; // edge case with one single bar
export const MIN_NUMBER_OF_BAR_FOR_RESPONSIVE_WIDTH = 3;

// legacy variables
// please refer to new plot design above

export const FONT_STYLE = {
  size: parseInt(styles.fontSizeXXSmall),
  color: styles.legacyPlotFontColor,
  family: styles.fontFamily,
};

export const PERFORMANCE_REALTIME_FONT_STYLE = {
  size: parseInt(styles.fontSizeXSmall),
  color: styles.legacyPlotFontColorLight,
};

export const TITLE_FONT_STYLE = {
  size: parseInt(styles.fontSizeXSmall),
  color: styles.legacyPlotFontColor,
  family: styles.fontFamily,
};

export const WELL_GUARDIAN_FONT_STYLE = {
  size: parseInt(styles.fontSizeXSmall),
  color: styles.wgRoyal,
  family: styles.fontFamily,
};

export const applicationBackgroundColor = styles.applicationBackgroundColor;
export const plotAxisGridColor = styles.plotAxisGridColor;
export const paperBackgroundColor = styles.paperBackgroundColor;
export const plotBackgroundColor = styles.plotBackgroundColor;
export const plotBackgroundColorDarker = styles.plotBackgroundColorDarker;
export const plotBackgroundColorTransparent = styles.transparent;
export const plotBackgroundColorLight = styles.plotBackgroundColorLight;
export const plotDeactivatedFillColor = styles.plotDeactivatedFillColor;
export const plotDeactivatedLineColor = styles.plotDeactivatedLineColor;
export const plotLineColorGreen = styles.plotLineColorGreen;
export const plotLineColorBlue = styles.plotLineColorBlue;
export const plotLineColorOrange = styles.plotLineColorOrange;
export const plotLineColorRed = styles.plotLineColorRed;
export const plotLineColorPurple = styles.plotLineColorPurple;
export const contextCategoryColor = styles.contextCategoryColor;
export const gasCategoryMediumColor = styles.gasCategoryMediumColor;
export const hydraulicsCategoryMediumColor = styles.hydraulicsCategoryMediumColor;
export const mechanicsCategoryMediumColor = styles.mechanicsCategoryMediumColor;
export const plotlyGasHigh = styles.plotlyGasHigh;
export const plotlyGasMedium = styles.plotlyGasMedium;
export const plotlyGasLow = styles.plotlyGasLow;
export const plotlyHydraulicsHigh = styles.plotlyHydraulicsHigh;
export const plotlyHydraulicsMedium = styles.plotlyHydraulicsMedium;
export const plotlyHydraulicsLow = styles.plotlyHydraulicsLow;
export const plotlyMechanicsHigh = styles.plotlyMechanicsHigh;
export const plotlyMechanicsMedium = styles.plotlyMechanicsMedium;
export const plotlyMechanicsLow = styles.plotlyMechanicsLow;
export const plotlyEnsembleHigh = styles.plotlyEnsembleHigh;
export const plotlyEnsembleMedium = styles.plotlyEnsembleMedium;
export const plotlyEnsembleLow = styles.plotlyEnsembleLow;
export const plotlyFillBlue = styles.plotlyFillBlue;
export const plotlyFillBlueDark = styles.plotlyFillBlueDark;
export const plotlyFillWhite = styles.plotlyFillWhite;
export const plotlyFillGrey = styles.plotlyFillGrey;
export const plotlyRedLight = styles.plotlyRedLight;
export const plotlyMethane = styles.plotlyMethane;
export const plotlyEthane = styles.plotlyEthane;
export const plotlyPropane = styles.plotlyPropane;
export const plotlyButane = styles.plotlyButane;
export const plotlyPentane = styles.plotlyPentane;
export const plotlyTotalGasOut = styles.plotlyTotalGasOut;
export const plotlyGasOutAverage = styles.plotlyGasOutAverage;
export const plotLineColorYellow = styles.plotLineColorYellow;
export const plotlyFillGreen = styles.plotlyFillGreen;
export const plotlyLineAmber = styles.plotlyLineAmber;
export const plotlyLineBrown = styles.plotlyLineBrown;
export const plotlyLineLightBlue = styles.plotlyLineLightBlue;
export const plotlyLineGrey = styles.plotlyLineGrey;
export const worldMapMarkerDeactivated = styles.worldMapMarkerDeactivated;
export const worldMapMarkerHigh = styles.worldMapMarkerHigh;
export const worldMapMarkerMedium = styles.worldMapMarkerMedium;
export const worldMapMarkerLow = styles.worldMapMarkerLow;
export const alarmGreen = styles.alarmGreen;
export const alarmOrange = styles.alarmOrange;
export const alarmRed = styles.alarmRed;
export const alarmGrey = styles.alarmGrey;
export const greyTransparent = styles.greyTransparent;
export const plotlyElapsedProductiveTimeColor = styles.plotlyElapsedProductiveTimeColor;
export const plotlyElapsedInvisibleLostTimeColor = styles.plotlyElapsedInvisibleLostTimeColor;
export const plotlyElapsedNonProductiveTimeColor = styles.plotlyElapsedNonProductiveTimeColor;
export const plotlyElapsedWaitOnWeatherTimeColor = styles.plotlyElapsedWaitOnWeatherTimeColor;
export const plotlyBCWTimeColor = styles.plotlyBCWTimeColor;
export const plotlyPlannedTimeColor = styles.plotlyPlannedTimeColor;
export const plotlyBCWTraceColor = styles.plotlyBCWTraceColor;
export const plotlyPlannedTraceColor = styles.plotlyPlannedTraceColor;
export const plotlyRealizedTraceColor = styles.plotlyRealizedTraceColor;
export const plotlyAverageTraceColor = styles.plotlyAverageTraceColor;
export const plotlyForecastTraceColor = styles.plotlyForecastTraceColor;
export const plotlyStuckWeightsLow = styles.plotlyStuckWeightsLow;
export const plotlyStuckWeightsMedium = styles.plotlyStuckWeightsMedium;
export const plotlyStuckWeightsHigh = styles.plotlyStuckWeightsHigh;
export const plotlyStuckTorqueLow = styles.plotlyStuckTorqueLow;
export const plotlyStuckTorqueMedium = styles.plotlyStuckTorqueMedium;
export const plotlyStuckTorqueHigh = styles.plotlyStuckTorqueHigh;
export const plotlyStuckHydraulicsLow = styles.plotlyStuckHydraulicsLow;
export const plotlyStuckHydraulicsMedium = styles.plotlyStuckHydraulicsMedium;
export const plotlyStuckHydraulicsHigh = styles.plotlyStuckHydraulicsHigh;
export const plotlyStuckDragsLow = styles.plotlyStuckDragsLow;
export const plotlyStuckDragsMedium = styles.plotlyStuckDragsMedium;
export const plotlyStuckDragsHigh = styles.plotlyStuckDragsHigh;
export const plotlyPinkBright = styles.plotlyPinkBright;
export const plotlyStuckEnsembleHigh = styles.plotlyStuckEnsembleHigh;
export const plotlyStuckEnsembleMedium = styles.plotlyStuckEnsembleMedium;
export const plotlyStuckEnsembleLow = styles.plotlyStuckEnsembleLow;
export const plotlyHeadcountBars = styles.plotlyHeadcountBars;
export const plotlySafetyCardsBars = styles.plotlySafetyCardsBars;
export const plotlySafetyIncidentsBars = styles.plotlySafetyIncidentsBars;
export const plotlyConnectionTime = styles.plotlyConnectionTime;
export const plotlyActivityTime = styles.plotlyActivityTime;
export const plotlyTargetLine = styles.plotlyTargetLine;
export const plotlyHeatMapNeutral = styles.plotlyHeatMapNeutral;
export const plotlyHeatMapRed = styles.plotlyHeatMapRed;
export const plotlyHeatMapGreen = styles.plotlyHeatMapGreen;
export const plotlyGreenLight = styles.plotlyGreenLight;
export const white = styles.white;
export const whiteTransparent = styles.whiteTransparent;
export const plotlyOffsetTimeBreakDownGraphPinkBright =
  styles.plotlyOffsetTimeBreakDownGraphPinkBright;
export const plotlyOffsetTimeBreakDownGraphPinkLight =
  styles.plotlyOffsetTimeBreakDownGraphPinkLight;
export const plotlyOffsetTimeBreakDownGraphPink = styles.plotlyOffsetTimeBreakDownGraphPink;
export const plotlyOffsetTimeBreakDownGraphBlueLight =
  styles.plotlyOffsetTimeBreakDownGraphBlueLight;
export const plotlyOffsetTimeBreakDownGraphBlue = styles.plotlyOffsetTimeBreakDownGraphBlue;
export const plotlyOffsetTimeBreakDownGraphBlueDark = styles.plotlyOffsetTimeBreakDownGraphBlueDark;
export const plotlyWgOrange = styles.plotlyWgOrange;
export const plotlyWgBlue = styles.plotlyWgBlue;
export const plotlyWgLightGreen = styles.plotlyWgLightGreen;
export const ropPlotNextBopDateLine = styles.ropPlotNextBopDateLine;
export const ropOptimizedForecastLine = styles.ropOptimizedForecastLine;
export const plotlyLegendLightGrey = styles.plotlyLegendLightGrey;
export const ropTrafficLightLow = styles.ropTrafficLightLow;
export const ropTrafficLightMedium = styles.ropTrafficLightMedium;
export const ropTrafficLightHigh = styles.ropTrafficLightHigh;
export const defaultHorizontalBg = styles.ropTrafficLightDefault;
export const plotColorDarkest = styles.plotBackgroundColorDarkest; // [TODO] Harmonise plot background color with UI designers
export const drillXStrongGrey = styles.hoverLabelStrongGrey;
export const plotlyOperationsPageColor = styles.plotlyOperationsPageColor;

export const getPlotlySpacing = (multiplier: number) => {
  return parseInt(styles.spacingUnit) * multiplier;
};
